import { Oval } from 'react-loader-spinner'

function OvalLoader({
  wrapperClass = '',
  color = '#093FA7', // #4747EB
  secondaryColor = '#0066FF',
  height = 45,
  width = 45,
  size,
  strokeWidth = 5,
}) {
  return (
    <Oval
      wrapperClass={'oval_loader ' + wrapperClass}
      color={color}
      secondaryColor={secondaryColor}
      height={size || height}
      width={size || width}
      strokeWidth={strokeWidth}
    />
  )
}

export default OvalLoader
